import { render, staticRenderFns } from "./AccountsSendUnsetMessagesModal.vue?vue&type=template&id=0916fdf3&scoped=true"
import script from "./AccountsSendUnsetMessagesModal.vue?vue&type=script&lang=js"
export * from "./AccountsSendUnsetMessagesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0916fdf3",
  null
  
)

export default component.exports